import { sql } from "drizzle-orm";
import {
	pgTable,
	timestamp,
	text,
	boolean,
	unique,
	uniqueIndex,
	uuid,
	jsonb
} from "drizzle-orm/pg-core";

import type { UserSettings } from "@fergmar/contracts/user-settings";

export const users = pgTable(
	"users",
	{
		id: text("id").primaryKey().notNull(),
		uuid_id: uuid("uuid_id").defaultRandom().unique("users_uuid_id_unique"),
		provider: text("provider").default("email").notNull(),
		providerId: text("provider_id").default("").notNull(),
		email: text("email").notNull(),
		verified: boolean("verified").default(false).notNull(),
		receiveEmail: boolean("receive_email").default(true).notNull(),
		password: text("password"),
		token: text("token"),
		createdAt: timestamp("created_at", { withTimezone: true, mode: "string" })
			.defaultNow()
			.notNull(),
		settings: jsonb("settings").$type<UserSettings>().default({}).notNull(),
		updatedAt: timestamp("updated_at", { mode: "string", precision: 3 })
			.$onUpdate(() => new Date().toISOString())
			.defaultNow()
			.notNull(),
		deactivatedAt: timestamp("deactivated_at", { withTimezone: true, mode: "string" }),
		displayName: text("display_name"),
		avatarUrl: text("avatar_url"),
		accountTypes: text("account_types").array().default([]).notNull()
	},
	(table) => [
		uniqueIndex("users_email_normalized_unique").on(sql`lower(trim(${table.email}))`),
		unique("users_token_unique").on(table.token)
	]
);
